// E-commerce domain dictionary. Mirrors infermap/dictionaries/ecommerce.yaml.
export const DOMAIN: Record<string, readonly string[]> = {
  product_id: [
    "sku",
    "product_code",
    "prod_id",
    "item_id",
    "item_code",
    "catalog_number",
  ],
  product_name: [
    "item_name",
    "prod_name",
    "title",
    "product_title",
    "item_title",
  ],
  product_description: [
    "description",
    "desc",
    "prod_desc",
    "item_desc",
    "long_description",
  ],
  brand: ["manufacturer", "make", "brand_name", "vendor"],
  category: ["product_category", "category_name", "dept", "department"],
  price: [
    "unit_price",
    "list_price",
    "retail_price",
    "msrp",
    "sale_price",
    "selling_price",
  ],
  cost: ["unit_cost", "wholesale_cost", "cost_price", "cogs", "landed_cost"],
  quantity: [
    "qty",
    "quantity_ordered",
    "qty_ordered",
    "units",
    "order_qty",
  ],
  inventory: [
    "stock",
    "on_hand",
    "qty_on_hand",
    "stock_level",
    "available_qty",
    "inventory_count",
  ],
  order_id: [
    "order_number",
    "order_num",
    "order_no",
    "order_ref",
    "po_number",
    "purchase_order",
  ],
  order_date: [
    "ordered_at",
    "order_placed",
    "order_created",
    "purchased_at",
    "purchase_date",
  ],
  order_status: ["status", "fulfillment_status", "order_state"],
  customer_id: ["cust_id", "buyer_id", "shopper_id", "account_id", "user_id"],
  customer_email: ["buyer_email", "shopper_email", "contact_email"],
  shipping_address: [
    "ship_to",
    "ship_addr",
    "delivery_address",
    "shipping_addr",
  ],
  billing_address: ["bill_to", "bill_addr", "billing_addr", "invoice_address"],
  shipping_method: [
    "ship_method",
    "delivery_method",
    "carrier",
    "shipping_carrier",
  ],
  tracking_number: ["tracking_num", "tracking_id", "awb", "shipment_id"],
  payment_method: ["pay_method", "payment_type", "tender_type"],
  discount: [
    "discount_amt",
    "discount_amount",
    "promo_amt",
    "coupon_amount",
    "markdown",
  ],
  discount_code: ["promo_code", "coupon_code", "voucher_code"],
  subtotal: ["sub_total", "merchandise_total", "items_total"],
  total: ["grand_total", "order_total", "total_amount", "final_amount"],
  tax_amount: ["tax", "sales_tax", "vat", "tax_total"],
  shipping_cost: ["shipping_fee", "ship_cost", "delivery_fee", "freight"],
};
